import { render, staticRenderFns } from "./RiskPathwayIllu.vue?vue&type=template&id=55480435&scoped=true&"
import script from "./RiskPathwayIllu.vue?vue&type=script&lang=js&"
export * from "./RiskPathwayIllu.vue?vue&type=script&lang=js&"
import style0 from "./RiskPathwayIllu.vue?vue&type=style&index=0&id=55480435&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55480435",
  null
  
)

export default component.exports